import { IconContainer } from '@/components/icons';
import { BetaBadge } from '@/lib';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { BaseDestinationItemData } from './types';

type BaseDestinationItemProps<T extends BaseDestinationItemData> = {
  connector: T;
  showBetaBadge?: boolean;
} & PropsWithChildren

export const BaseDestinationItem = <T extends BaseDestinationItemData>({ connector, showBetaBadge = false, children }: BaseDestinationItemProps<T>) => {
  const { name, icon } = connector;

  return (
    <div className={classNames('flex flex-col rounded-xl border min-w-[320px] min-h-[226px] p-4 bg-white-100')}>
      <div className='flex justify-between'>
        <IconContainer path={icon} className='h-16 w-[64px]' />
        {showBetaBadge && <BetaBadge />}
      </div>
      <p className='mt-3 font-semibold'>{name}</p>
      <div className='grow content-end'>{children}</div>
    </div>
  );
};
